import {
  ColumnLayout,
  Container,
  Header,
} from '@cloudscape-design/components';
import {
  BoolStatus,
  formatEnum,
  formatNumber,
  Value,
} from 'features/plc/components/common';
import {
  CONTROLLER_STATE_LABELS,
  getPathName,
  HEAT_ZONE_FAULT_REASON_LABELS,
  HEAT_ZONE_STAGE_LABELS,
  PLC_PATHS,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValues } from 'features/plc/providers/PLCProvider';
import React from 'react';

const renderValue = (value, formatter) => (formatter ? formatter(value) : (value ?? '--'));

const createHeatBlockFields = (heatBlock) => ([
  { label: 'Fault', path: heatBlock.fault, kind: 'bool' },
  { label: 'Fault Latched', path: heatBlock.faultLatched, kind: 'bool' },
  { label: 'Fault Reason', path: heatBlock.faultReason, formatter: (value) => formatEnum(value, HEAT_ZONE_FAULT_REASON_LABELS) },
  { label: 'Max Overshoot', path: heatBlock.maxOverShoot, formatter: (value) => formatNumber(value, ' °C') },
  { label: 'Heat Stage', path: heatBlock.heatStage, formatter: (value) => formatEnum(value, HEAT_ZONE_STAGE_LABELS) },
  { label: 'PID Kp', path: heatBlock.pid.kp, formatter: (value) => formatNumber(value) },
  {
    label: 'Controller State',
    path: heatBlock.controllerState,
    formatter: (value) => formatEnum(value, CONTROLLER_STATE_LABELS),
  },
  { label: 'PID Tn (s)', path: heatBlock.pid.tnSeconds, formatter: (value) => formatNumber(value) },
  { label: 'Analog Output', path: heatBlock.analogOutput },
  { label: 'PID Tv (s)', path: heatBlock.pid.tvSeconds, formatter: (value) => formatNumber(value) },
  { label: 'Stable For Hold', path: heatBlock.stableForHold, kind: 'bool' },
  { label: 'PID Td (s)', path: heatBlock.pid.tdSeconds, formatter: (value) => formatNumber(value) },
]);

const HEAT_BLOCK_SECTIONS = [
  {
    title: 'Upper Heat Block',
    fields: createHeatBlockFields(
      PLC_PATHS.status.upperHeatBlock,
    ),
  },
  {
    title: 'Lower Heat Block',
    fields: createHeatBlockFields(
      PLC_PATHS.status.lowerHeatBlock,
    ),
  },
];

export default function HeatBlockStatus() {
  const values = usePLCValues(
    HEAT_BLOCK_SECTIONS.flatMap((section) => section.fields.map((field) => field.path)),
  );

  return (
    <ColumnLayout columns={2} variant="text-grid">
      {HEAT_BLOCK_SECTIONS.map((section) => (
        <Container key={section.title} header={<Header variant="h2">{section.title}</Header>}>
          <ColumnLayout columns={2}>
            {section.fields.map((field) => {
              const value = values[getPathName(field.path)];

              if (field.kind === 'bool') {
                return (
                  <BoolStatus
                    key={getPathName(field.path)}
                    label={field.label}
                    value={value}
                  />
                );
              }

              return (
                <Value
                  key={getPathName(field.path)}
                  label={field.label}
                  value={renderValue(value, field.formatter)}
                />
              );
            })}
          </ColumnLayout>
        </Container>
      ))}
    </ColumnLayout>
  );
}
